import React from 'react';

import {FilterOptionsState} from '@mui/base/useAutocomplete/useAutocomplete';
import {Autocomplete, Box, TextField, Typography} from '@mui/material';

import {ProjectKeysStatusesPerLang} from '@bumpy/i18n_common';

type Props = {
  selected?: string;
  label: string;
  keysStatusesPerLang: ProjectKeysStatusesPerLang;
  onFocus: () => void;
  onBlur: () => void;
  onSelect: (option: string) => void;
};

export const KeyAutocomplete: React.FC<Props> = (props: Props) => {
  return (
    <Autocomplete
      fullWidth
      value={props.selected}
      options={Object.keys(props.keysStatusesPerLang)}
      filterOptions={(options: string[], state: FilterOptionsState<string>) => {
        const lower = state.inputValue.trim().toLowerCase();
        return options.filter(
          (o) =>
            (o.toLowerCase().includes(lower) ||
              props.keysStatusesPerLang[o]?.text
                ?.toLowerCase()
                .includes(lower)) ??
            false,
        );
      }}
      renderOption={(
        params: React.HTMLAttributes<HTMLLIElement>,
        option: string,
      ) => (
        <Box component="li" {...params}>
          <Box>
            <Typography variant="body1">
              {props.keysStatusesPerLang[option]?.text ?? option}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              fontStyle="italic"
              fontSize="0.875rem"
            >
              {option}
            </Typography>
          </Box>
        </Box>
      )}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      renderInput={(params) => (
        <TextField {...params} variant="standard" label={props.label} />
      )}
      onChange={(_, value) => {
        if (value) {
          props.onSelect(value);
        }
      }}
    />
  );
};
